/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs */

const en__field__enum_teachingsubjectinterest_subject_geography18 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

const de__field__enum_teachingsubjectinterest_subject_geography18 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erdkunde / Geographie`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_geography18 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Geography18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_geography18(inputs)
	return de__field__enum_teachingsubjectinterest_subject_geography18(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_geography18 as "_field__enum_teachingSubjectInterest_SUBJECT_GEOGRAPHY" }